import SubmitHandler from '../../submit-handler';
import {initCounter} from '../../../components/counter';
import Uploader from '../../uploader/uploader';
import TwoUploader from '../../uploader/two-uploader';
import phoneMask from '../../../components/phone-mask';

/**
 * Initializing a form
 */
class Base {
    modal;
    form;
    checkFields;
    analytics;
    placeId;
    selectors;
    rulesValidate = {};
    rulesMessages = {};
    twoUploaderFiles;

    /** @type {string} */
    formName;

    /**
     * @param {Modal} modal
     * @param {Object} formData
     */
    constructor({modal, formData = {}}) {
        this.modal = modal;
        this.form = modal.activeModal.querySelector('form');
        const {checkFields = {}, analytics = {}, placeId = 0, name} = formData;
        this.checkFields = checkFields;
        this.analytics = analytics;
        this.placeId = placeId;
        this.formName = name;
        this.selectors = {
            inputMask: '.inputmask-phone',
            readTerm: '.readItTerm',
            note: '.note',
        };
        this.init();
    }

    /**
     * Run
     * @param {{modal: Modal, formData: Object}} data
     * @returns {Base}
     */
    static run(data) {
        return new Base(data);
    }

    /**
     * Check
     * @returns {boolean}
     */
    validateCheck() {
        const elem = this.form.querySelector(this.selectors.readTerm);

        if (elem && !elem.checked) {
            const elemNote = this.form.querySelector(this.selectors.note);
            elemNote.innerHTML = 'Подтвердите, что вы ознакомлены с условиями!';

            return false;
        }

        return true;
    }

    /**
     * Validate rules
     */
    setValidateRules() {
        if (this.checkFields && Object.prototype.toString.call(this.checkFields) === '[object Object]') {
            for (let key in this.checkFields) {
                if (Object.prototype.hasOwnProperty.call(this.checkFields, key)) {
                    const rules = this.checkFields[key];

                    if (Object.prototype.toString.call(rules) === '[object Object]') {
                        for (let ruleName in rules) {
                            if (Object.prototype.hasOwnProperty.call(rules, ruleName)) {
                                const name = `${this.formName}[${key}]`;
                                const {label, item} = rules[ruleName];

                                if (Object.prototype.hasOwnProperty.call(this.rulesMessages, name)) {
                                    this.rulesMessages[name][ruleName] = label;
                                    this.rulesValidate[name][ruleName] = item;
                                } else {
                                    this.rulesMessages[name] = {[ruleName]: label};
                                    this.rulesValidate[name] = {[ruleName]: item};
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * Callback handler
     */
    submitHandler = () => {
        if (this.validateCheck() === false) {
            return;
        }

        SubmitHandler.run({
            modal: this.modal,
            form: this.form,
            analytics: this.analytics,
            placeId: this.placeId,
            files: this.twoUploaderFiles.getFiles(),
        });
    };

    /** Validate */
    initValidate() {
        if (!this.form) {
            return;
        }

        this.setValidateRules();

        $(this.form).validate({
            rules: this.rulesValidate,
            messages: this.rulesMessages,
            submitHandler: this.submitHandler,
            errorClass: 'invalid',
            errorPlacement(error, Element) {
                error.addClass('error-pane error-pane-side');
                error.wrapInner($('<div>').addClass('error-pane-inner'));
                Element.after(error);
            },
        });
    }

    /**
     * Render Init
     */
    render() {
        phoneMask(this.selectors.inputMask);
        this.initValidate();
        initCounter(this.modal.activeModal);

        Uploader.run({
            wrapElem: this.modal.activeModal,
        });

        this.twoUploaderFiles = TwoUploader.run({
            wrapElem: this.modal.activeModal,
        });
    }

    /**
     * Init
     */
    init() {
        this.render();
    }
}

export default Base;
